
















































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { IDashboardData } from "@/types/Dashboard.model";
import { MyOptions } from "@/charts/graphData";
import DashboardTotalCard from "./DashboardTotalCard.vue";
import DashboardEnseigneCard from "./DashboardEnseigneCard.vue";
import DashboardHistoricalCard from "./DashboardHistoricalCard.vue";
import DashboardCommandesEnCoursCard from "./DashboardCommandesEnCoursCard.vue";
import DashboardProfitCard from "./DashboardProfitCard.vue";
import DashboardCAEnCoursCard from "@/components/dashboard/DashboardCAEnCoursCard.vue";

@Component({
  components: {
    DashboardCAEnCoursCard,
    DashboardTotalCard,
    DashboardEnseigneCard,
    DashboardHistoricalCard,
    DashboardCommandesEnCoursCard,
    DashboardProfitCard,
  },
})
export default class DashboardDesktopGrid extends Vue {
  @Prop() public dashboardData!: IDashboardData;
  @Prop() public isTTC!: boolean;
  @Prop() public myOptions!: MyOptions;

  public onRenderFinished() {
    this.$emit("renderFinished");
  }

  public onInit() {
    this.$emit("init");
  }

  get client(): string {
    return this.$store.getters["getClient"];
  }

  get getGlobal(): boolean {
    return this.$store.getters["getGlobal"];
  }
}
